import React, { Component } from 'react';
import { getContactUsList, removeContactUsItem } from '../../modules/Api';
import { Button, notification } from 'antd';
import ReactTable from 'react-table';
import moment from 'moment-jalaali';
import history from '../../modules/History';
import ACL from '../../components/ACL';

class ContactUs extends Component {
    constructor() {
        super();
        this.state = {
            items: [],
            pageSize: 15,
            count: 0,
            last_page: 1,
        }
    }

    componentDidMount() {
        this.fetchData();
    }

    fetchData = (query = '') => {
        getContactUsList(query, (data) => {this.setState({
            items: data.data,
            last_page: data.last_page,
            count: data.total,
            pageSize: data.per_page
        })});
        //getContactUsCount(query, (count) => {this.setState({count})});
    }

    onChange(state) {
        this.setState({pageSize: state.pageSize});
        const title = state.filtered.find(f => f.id === 'message');
        const search = title ? title.value : '';
        const query = `page=${state.page  + 1}&per_page=${state.pageSize}&query=${search}`
        this.fetchData(query);
    }

    removeItem(id) {
        const warningMessage = `آیا از حذف پیام اطمینان کامل دارید ؟  !`;
        if (window.confirm(warningMessage)) {
            removeContactUsItem(id, () => {
                this.fetchData();
                notification.open({
                    message: `پیام با موفقیت حذف شد!`
                })
            })
        }
    }

    render() {
        const columns = [
            {
                Header: 'آیدی',
                accessor: 'id',
            },
            {
                Header: 'عنوان',
                Cell: row => (<span title={row.original.subject}> {row.original.subject} </span>)
            },
            {
                Header: 'متن پیام',
                accessor: 'message',
                id: 'message',
                filterable: true,
                Cell: (row) => (<span title={row.original.message}> {row.original.message}</span>)
            },
            {
                Header: 'نام فرستنده',
                accessor: 'name',
                Cell: (row) => (<span title={row.original.name}> {row.original.name} </span>)
            },
            {
                Header: 'شماره تماس',
                accessor: 'phone',
                Cell: (row) => (<span title={row.original.phone}> {row.original.phone} </span>)
            },
            {
                Header: 'ایمیل',
                accessor: 'email',
                Cell: (row) => (<span title={row.original.email}> {row.original.email} </span>)
            },
            {
                Header: 'تاریخ ایجاد',
                accessor: 'created_at',
                Cell: (row) => (<span>{row.original.created_at && moment(row.original.created_at).format('jYYYY/jMM/jDD')}</span>)
            },
            {
                Header: 'حذف',
                accessor: 'delete',
                Cell: (row) => (
                    <React.Fragment>
                        <ACL component="span" has_permission="contact_delete"><span onClick={() => {this.removeItem(row.original.id)}} style={{color: 'tomato', cursor: 'pointer', marginTop: '20%'}} >X </span></ACL>
                        <ACL component="span" has_permission="contact_history"><span onClick={() => history.item.push(`/history/contactus/${row.original.id}`)} className="link">H</span></ACL>
                    </React.Fragment>
                )
            },
        ]
        return(
            <div style={{textAlign: 'center'}}>
                <div class="btn-container">
                    <Button type="secondary" onClick={() => history.item.push(`/history/contactus`)}>تاریخچه تغییرات</Button>
                </div>
                <ReactTable
                    data={this.state.items}
                    columns={columns}
                    manual
                    onFetchData={state => this.onChange(state)}
                    defaultPageSize={this.state.pageSize}
                    pages={this.state.last_page}/>
            </div>
        );
    }
}

export default ContactUs;


// WEBPACK FOOTER //
// ./src/containers/ContactUs/index.js